import React from "react";
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ReactComponent as InfoCircleSvg } from "go-component/images/svg/info-circle.svg";
import { PrintoutTemplateApi } from "../../../../../../../../../services/Api/Organization/types";
import PrintoutTemplateVisibilityOptionForm from "./PrintoutTemplateVisibilityOptionForm";

interface Props {
	form: UseFormReturn<PrintoutTemplateApi>;
}

const PrintoutTemplateVisibilityForm = ({ form }: Props) => {
	const { t } = useTranslation();

	return (
		<Card className={"mb-3"}>
			<Card.Body>
				<h6>
					{t("modules.printout_template.field.visibility.title")}
					<p>
						<small className="text-muted">
							{t("modules.printout_template.field.visibility_desc.title")}
						</small>
					</p>
				</h6>
				<div className={"d-flex flex-column gap-2"}>
					<PrintoutTemplateVisibilityOptionForm
						label={t("modules.printout_template.field.print_pickup_at.title")}
						name="print_pickup_at"
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("modules.printout_template.field.employee.title")}
						name={"print_employee"}
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("modules.printout_template.field.point_of_sale.title")}
						name={"print_point_of_sale"}
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("modules.printout_template.field.direction.title")}
						name={"print_direction"}
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("common.word.comment")}
						name={"print_comment"}
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("common.word.table")}
						name={"print_table"}
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("modules.printout_template.field.number_of_guests.title")}
						name={"print_number_of_guests"}
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("modules.printout_template.field.order_type.title")}
						name={"print_order_type"}
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("modules.printout_template.field.order_source.title")}
						name={"print_order_source"}
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("modules.printout_template.field.course.title")}
						name={"print_course"}
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("modules.printout_template.field.print_items.title")}
						name="items"
						form={form}
						alwaysPrint
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("modules.printout_template.field.print_extra_space.title")}
						name="print_extra_space"
						form={form}
						withoutAdditionalOptions
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("modules.printout_template.field.print_storno.title")}
						name="print_storno"
						form={form}
						withoutAdditionalOptions
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={
							<div className="d-flex">
								<span className="d-inline-block me-1">
									{t("modules.printout_template.field.print_items_on_course_printout.title")}
								</span>
								<div className="d-inline-block">
									<OverlayTrigger
										placement="top"
										overlay={
											<Tooltip id="tooltip">
												<span className="help-text">
													{t(
														"modules.printout_template.field.print_items_on_course_printout.help_text.title"
													)}
												</span>
											</Tooltip>
										}
									>
										<InfoCircleSvg />
									</OverlayTrigger>
								</div>
							</div>
						}
						name="print_items_on_course_printout"
						form={form}
						withoutAdditionalOptions
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("modules.printout_template.field.print_additions.title")}
						name="additions"
						form={form}
						alwaysPrint
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("modules.printout_template.field.included_additions.title")}
						name={"print_included_additions"}
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("modules.printout_template.field.seat.title")}
						name={"print_seat"}
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("modules.printout_template.field.item_comment.title")}
						name={"print_item_comment"}
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("modules.printout_template.field.prices.title")}
						name={"print_prices"}
						form={form}
						withoutAdditionalOptions
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("modules.printout_template.field.origin_of_item.title")}
						name={"print_origin_of_item"}
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("common.word.client")}
						name={"print_client"}
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("common.word.address", { ns: "lib" })}
						name={"print_address"}
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("modules.printout_template.field.delivery_employee.title")}
						name={"print_delivery_employee"}
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("common.word.payment_method")}
						name={"print_payment_method"}
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("modules.printout_template.field.print_payment_status.title")}
						name="print_payment_status"
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("common.word.other_directions")}
						name="print_other_directions"
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("modules.printout_template.field.print_direction_if_different.title")}
						name="print_direction_if_different"
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("common.word.order_number")}
						name={"print_number"}
						form={form}
					/>
					<PrintoutTemplateVisibilityOptionForm
						label={t("modules.printout_template.field.print_total_price.title")}
						name="print_total_price"
						form={form}
					/>
				</div>
			</Card.Body>
		</Card>
	);
};

export default PrintoutTemplateVisibilityForm;
